import { type AnchorHTMLAttributes, forwardRef } from 'react';
import styled from 'styled-components';

type AnchorProps = AnchorHTMLAttributes<HTMLAnchorElement>;

const Anchor = styled.a<AnchorProps>(({ theme }) => ({
  textDecoration: 'underline',
  color: theme.colors.hyperlink,
  'p, span, h1, h2, h3, h4, h5, h6': {
    color: theme.colors.hyperlink,
  },
}));

const AnchorWrapper = forwardRef<HTMLAnchorElement, AnchorProps>(({ href, children, ...rest }, ref) => {
  if (!href) return <>{children}</>;

  return (
    <Anchor href={href} {...rest} ref={ref}>
      {children}
    </Anchor>
  );
});

export { AnchorWrapper };
